import React,{ Component, PropTypes } from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

class LinkWithTooltip extends Component{
  
  render() {
    let tooltipText = <div dangerouslySetInnerHTML={{__html: this.props.tooltip}} />
    let tooltip = <Popover id={`${Date.now().toString(35)}-${this.props.id}`} bsClass="sppb-popover" title={this.props.title}>{tooltipText}</Popover>;

    var position = 'top';

    if(this.props.position) {
      position = this.props.position;
    }

    return (
      <OverlayTrigger
        overlay={tooltip} placement={position}
        delayShow={100} delayHide={150}
        trigger="click"
        rootClose={true}
        >
        {this.props.children}
      </OverlayTrigger>
    );
  }
}

export default LinkWithTooltip;



// WEBPACK FOOTER //
// ./src/helpers/tooltip.js